// Geneva expects <= 2 to be of 'error' classification
export enum LoggingLevel {
    error = 0,
    warn = 1,
    info = 3,
    metric = 4,
    verbose = 5,
    debug = 6
}

export interface ILogger {
    level: LoggingLevel;

    log(obj: any): void;
}
